<template>
  <div class="view" :class="viewClass">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  previewMode: {
    type: Boolean,
    default: false,
  },
});

const viewClass = computed(() => ({ "--preview-mode": props.previewMode }));
</script>

<style lang="scss" scoped>
.view {
  --margin-block: var(--sp-comp-dtv-view-margin-block, 0);
  --padding-block: var(--dtv-view-padding-block, var(--sp-comp-dtv-view-padding-block, 1.2rem));
  --min-height: calc(var(--dtv-app-content-min-height) + (var(--padding-block) * 2));
  background-color: var(--sp-comp-dtv-view-background-color, white);
  border-radius: var(--sp-comp-dtv-view-border-radius, var(--sp-ref-border-radius-sm, 0));
  display: flex;
  justify-content: center;
  margin-block: var(--margin-block);
  max-width: var(--sp-comp-dtv-view-max-width, 100%);
  min-height: var(--min-height, fit-content);
  overflow: hidden;
  padding-block: var(--padding-block);
  position: relative;

  &.--preview-mode {
    --margin-block: var(--sp-comp-dtv-view-preview-margin-block, 4vw);
    --padding-block: var(--sp-comp-dtv-view-preview-padding-block, 4vw);
    max-width: var(--sp-comp-dtv-view-preview-max-width, 100%);
    border: var(--sp-comp-dtv-view-border, 1px solid #ccc);
    margin-inline: var(--sp-comp-dtv-view-preview-margin-inline, 4vw);
    padding-inline: clamp(0.25rem, 1vw, 1rem);
  }
  // Fade outs pseudo slides
  &::after,
  &::before {
    display: var(
      --dtv-view-fade-out-pseudo-slides-display,
      var(--sp-comp-dtv-view-fade-out-pseudo-slides-display, block)
    );
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 3;
    width: 8vw;
    opacity: 1;
    pointer-events: none;
  }
  &::after {
    left: 0;
    background: linear-gradient(to right, var(--sp-comp-dtv-view-background-color, white), transparent);
  }
  &::before {
    right: 0;
    background: linear-gradient(to left, var(--sp-comp-dtv-view-background-color, white), transparent);
  }
}
</style>
